import { render, staticRenderFns } from "./PriceWidget.vue?vue&type=template&id=140f1989&scoped=true"
import script from "./PriceWidget.vue?vue&type=script&lang=js"
export * from "./PriceWidget.vue?vue&type=script&lang=js"
import style0 from "./PriceWidget.vue?vue&type=style&index=0&id=140f1989&prod&lang=scss&scoped=true"
import style1 from "./PriceWidget.vue?vue&type=style&index=1&id=140f1989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f1989",
  null
  
)

export default component.exports